import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { actionGetDashboard } from "../../actions/Dashboard.action";
import styles from "./Style.module.css";
import TopRow from "./components/TopRow/TopRow.component";
import UsersList from "./components/Users/UserList.view";
import ProgramList from "./components/Programs/ProgramList.view";
import useDashboardHook from "./DashboardHook";

const DashboardPage = () => {
  const { dashboard, usersData,programData, handleDetail } = useDashboardHook();

  return (
    <>
      <div className={styles.container}>
      <div className={styles.tableContainer}>
        <div className={styles.tableColumn}>
        <TopRow dashboardData={dashboard} />
        <UsersList data={usersData} handleDetail={handleDetail}/>
        </div>
     
        <ProgramList data={programData}/>
        </div>
        {/* <div className={styles.tableContainer}>
        
          
          
        </div> */}
      </div>
    </>
  );
};

export default DashboardPage;
